
export const config = {
  apiBaseUrl: window._env_.REACT_APP_API_BASE_URL,
  internalApiKey: window._env_.REACT_APP_INTERNAL_API_KEY,
  tokenStorageKey: '@MetaForce:userToken'
}